import { toDisplayDateFormat } from 'lib/utils';

interface FormattedCalendarDateProps {
  date: string | Date;
}

const FormattedCalendarDate = ({ date }: FormattedCalendarDateProps) => <>{toDisplayDateFormat(date)}</>;

export default FormattedCalendarDate;
